module.exports = __webpack_public_path__ + "img/type-red.a9485d99.png";